import { useMemo } from 'react';
import { colors } from '../../../constants';

/**
 * Hook to calculate status distribution for charts
 * @param {Object} slaMetrics - SLA metrics object
 * @returns {Array} Status distribution array
 */
export const useSLAStatusDistribution = (slaMetrics) => {
  return useMemo(() => {
    const total = slaMetrics.queriesWithinSLA + slaMetrics.queriesAtRisk + slaMetrics.queriesBreached;
    const safeTotal = total > 0 ? total : 1; // Prevent division by zero
    return [
      { name: 'Within SLA', value: slaMetrics.queriesWithinSLA, color: colors.success, percentage: ((slaMetrics.queriesWithinSLA / safeTotal) * 100).toFixed(0) },
      { name: 'At Risk', value: slaMetrics.queriesAtRisk, color: colors.warning, percentage: ((slaMetrics.queriesAtRisk / safeTotal) * 100).toFixed(0) },
      { name: 'Breached', value: slaMetrics.queriesBreached, color: colors.error, percentage: ((slaMetrics.queriesBreached / safeTotal) * 100).toFixed(0) },
    ];
  }, [slaMetrics]);
};
